import { Spin } from 'antd';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useSessionStore } from '@/store/session';

/**
 * 登录墙。包在所有业务路由外面（见 router.tsx）。
 *
 * 🔴 status === 'loading' 时必须渲染占位而不是跳转：应用刚启动时会话还在校验中，
 * 这时跳登录页会让已登录用户每次刷新都闪一下登录页、甚至丢掉要去的目标地址。
 */
export default function RequireAuth() {
  const status = useSessionStore((s) => s.status);
  const location = useLocation();

  if (status === 'loading') {
    return (
      <div style={{ display: 'flex', justifyContent: 'center', paddingTop: '20vh' }}>
        <Spin size="large" />
      </div>
    );
  }

  if (status === 'anonymous') {
    // 带上来路，登录成功后跳回去，而不是一律回首页
    return <Navigate to="/login" replace state={{ from: location.pathname + location.search }} />;
  }

  return <Outlet />;
}
